import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from 'react-router-dom'
import ErrorBoundary from './components/common/Boundary'
import SplashScreen from './components/common/SplashScreen/SplashScreen'
import DefaultAction from './components/layouts/DefaultAction/DefaultAction'
import GlobalThemeConfig from './components/theme/GlobalThemeConfig'
import { router } from './routes/routerProvider'
import { ProvidersContext } from './shared/context'
import queryClient from './shared/queries/queryClient'
import { ReduxProvider } from './shared/redux'

export default function App() {
  return (
    <ErrorBoundary>
      <ReduxProvider>
        <QueryClientProvider client={queryClient}>
          <ProvidersContext>
            <GlobalThemeConfig>
              <ErrorBoundary>
                <SplashScreen />
                <DefaultAction />
                <RouterProvider router={router} />
              </ErrorBoundary>
            </GlobalThemeConfig>
          </ProvidersContext>
        </QueryClientProvider>
      </ReduxProvider>
    </ErrorBoundary>
  )
}
